import React from "react"

import { IMapProps } from "./GoogleMapTypes"

const DEFAULT_OPTIONS: google.maps.MapOptions = {
  disableDefaultUI: true
}

const Map: React.FC<IMapProps> = ({
  style,
  children,
  onClick,
  onIdle,
  ...options
}) => {
  const ref = React.useRef<HTMLDivElement>(null)
  const [map, setMap] = React.useState<google.maps.Map>()

  React.useEffect(() => {
    if (ref.current && !map) {
      setMap(new window.google.maps.Map(ref.current, {}))
    }
  }, [ref, map])

  React.useEffect(() => {
    if (map) {
      map.setOptions({ ...options, ...DEFAULT_OPTIONS })
    }
  }, [map, options])

  React.useEffect(() => {
    if (map) {
      ;["click", "idle"].forEach((eventName) =>
        google.maps.event.clearListeners(map, eventName),
      )

      if (onClick) {
        map.addListener("click", (e: any) => onClick(e, map))
      }

      if (onIdle) {
        map.addListener("idle", () => onIdle(map))
      }
    }
  }, [map, onClick, onIdle])

  return (
    <>
      <div ref={ref} style={style} />
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          // set the map prop on the child component
          return React.cloneElement(child, { map } as Partial<unknown>)
        }
      })}
    </>
  )
}

export default Map
